/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --gap: var(--nve-ref-space-xs);
  --font-size: var(--nve-ref-font-size-100);
  --color: var(--nve-sys-text-emphasis-color);
  --icon-color: var(--status-color);
  --icon-size: var(--nve-ref-size-400);
  --font-weight: var(--nve-ref-font-weight-medium);
  --justify-content: start;
  --align-items: center;
  --min-height: initial;
  --text-transform: initial;
  width: auto;
}

[internal-host] {
  --_icon-cancel-color: var(--color);
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  gap: var(--gap);
  color: var(--color);
  justify-content: var(--justify-content);
  align-items: var(--align-items);
  text-transform: var(--text-transform);
  display: flex;
  line-height: 1em;
  height: 100%;
}

slot[part='_content'] {
  display: contents;
  padding-inline-start: var(--nve-ref-size-600);
  padding-block-end: var(--nve-ref-size-200);
}

slot {
  display: flex;
  align-items: center;
  justify-content: var(--justify-content);
  gap: var(--nve-ref-space-xxs);
  min-height: var(--min-height);
}

slot:not([name='actions'], [name='prefix'], [name='icon']) {
  flex-grow: 1;
}

slot[name='prefix'],
slot[name='actions'] {
  font-weight: var(--nve-ref-font-weight-semibold);
}

::slotted(nve-button[container='flat']) {
  --color: inherit;
}

slot[name='actions'] {
  margin-inline-start: auto;
}

slot[name='prefix'] {
  margin-inline-end: var(--nve-ref-space-lg);
}

nve-icon {
  --color: var(--icon-color);
}

nve-icon:not([size='sm']) {
  --width: var(--icon-size);
  --height: var(--icon-size);
}

nve-icon[size='sm'] {
  padding: var(--nve-ref-size-50);
}

nve-icon-button {
  --color: var(--icon-color);
  margin-inline-start: auto;
}

::slotted([nve-text]) {
  color: inherit !important;
}

:host([status='success']),
:host([status='danger']) {
  --color: var(--status-color);
}

:host([status='scheduled']),
:host([status='queued']),
:host([status='pending']),
:host([status='starting']),
:host([status='running']),
:host([status='restarting']),
:host([status='stopping']),
:host([status='finished']),
:host([status='failed']),
:host([status='unknown']),
:host([status='ignored']) {
  --color: var(--status-color);
}

::slotted([slot='actions']) {
  --color: var(--status-color) !important;
}
